import GraphModal from 'graph-modal';

export const form = () => {
    const form = document.querySelector(".main-form__body");
    if (!form) return;

    const inputs = form.querySelectorAll("input[required], textarea[required]");
    const telInput = form.querySelector("#tel");
    const checkbox = form.querySelector("#politic");
    const submitBtn = form.querySelector(".main-form__btn");
    const commentInput = form.querySelector("#comment");
    const counter = form.querySelector(".main-form__inner-counter");

    const modal = new GraphModal();

    function validateForm() {
        let isValid = true;

        inputs.forEach((input) => {
            if (input.value.trim() === "") {
                isValid = false;
            }
        });

        const phoneDigits = telInput.value.replace(/\D/g, "");
        if (phoneDigits.length < 10) {
            isValid = false;
        }

        if (!checkbox.checked) {
            isValid = false;
        }

        submitBtn.disabled = !isValid;
    }

    if (commentInput && counter) {
        commentInput.addEventListener("input", () => {
            let value = commentInput.value;

            if (value.length > 100) {
                commentInput.value = value.slice(0, 100);
                value = commentInput.value;
            }

            counter.textContent = `${value.length}/100`;
        });

        commentInput.addEventListener("paste", (e) => {
            e.preventDefault();
            const pasteText = (e.clipboardData || window.clipboardData).getData("text");
            const allowed = pasteText.slice(0, 100 - commentInput.value.length);
            commentInput.value += allowed;
            counter.textContent = `${commentInput.value.length}/100`;
        });
    }

    form.addEventListener("input", validateForm);
    form.addEventListener("change", validateForm);

    form.addEventListener("submit", (e) => {
        e.preventDefault();
        validateForm();

        if (!submitBtn.disabled) {
            form.reset();
            submitBtn.disabled = true;

            if (counter) counter.textContent = "0/100";

            modal.open("thanks");
            setTimeout(() => {
                modal.close();
            }, 5000);
        }
    });
};
